import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/directorio-de-areas-historico-direccion';

/**
 * GET Dirección
 * @returns {Promise<object[]>}
 */
export const getAllDirecciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dirección by area ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDireccionesByDirectorioAreaID = async (id) => {
  try {
    const response = await API.get(`${baseURI}`, {
      params: { directorio_area: id },
    });
    return response.data.results;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Dirección
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const createDireccion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Dirección
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const updateDireccion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Dirección
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDireccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
